export default __webpack_public_path__ + "static/media/PS.d3d99cfe.png";